import { ScheduleListPage } from "./ScheduleListPage";
export default ScheduleListPage;
